var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{staticClass:"grid"}),_c('Menu'),_c('section',{staticClass:"mt-24 xl:mt-28"},[_c('h1',{staticClass:"text-center text-3xl mt-48 mb-72"},[_vm._v(" "+_vm._s(_vm.$t("thank-you"))+" ")])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }